import { createContext, useContext } from 'react';
import { RadioFieldSize } from '../radio-field/radio-field';

export type RadioGroupContextProps = {
  size: RadioFieldSize;
  error?: boolean | string;
};

export const RadioGroupContext = createContext<RadioGroupContextProps>({
  size: 'standard',
  error: false,
});

export const useRadioGroupContext = () => useContext(RadioGroupContext);
